import React, { Fragment } from 'react';
import { Dropdown, Text, IconButton, ChoiceGroup, TextField, Spinner, SpinnerType } from '@fluentui/react';
import style from './style.css';

const back = { iconName: 'Back' };

const daysOfWeek = {
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday',
	sunday: 'Sunday',
};

const showHours = [
	{
		key: 0,
		text: 'How long do you want your show to be?'
	},
	{
		key: 1,
		text: '1 hour'
	},
	{
		key: 2,
		text: '2 hours'
	}
]

const hours = Array(24)
	.fill(0)
	.map((s, i) => i);

const checkForEnter = (fun) => {
	return function (event) {
		if (event.keyCode == 13 || event.keyCode == 32) {
			return fun(event);
		}
	};
};

export default class Main extends React.Component {
	state = {
		category: null,
		apply: false,
		more_people: false
	};

	constructor (props) {
		super(props)

		try {
			let data = window.localStorage.getItem('saved-application-progress')

			data = JSON.parse(data || undefined)

			if (!data) {
				throw new Error('unsaved')
			}

			Object.assign(this.state, data, { askContinue: true })
		} catch (e) {

		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (prevState != this.state) {
			window.localStorage.setItem('saved-application-progress', JSON.stringify(this.state))
		}
	}

	_continue = () => {
		this.setState({
			askContinue: false
		})
	}

	_reset = () => {
		window.localStorage.setItem('saved-application-progress', null)

		window.location.reload();
	}

	render() {
		let { data } = this.props;

		if (!data) {
			return null;
		}

		let { vacancy } = data;

		if (!vacancy) {
			return (
				<div className={style.main}>
					<div className={style.background_image}>
						<img src='https://www.royalholloway.ac.uk/media/4296/clock-tower-detail.jpg' />
					</div>
					<h1>
						<Text variant='xxLarge'>Check back soon</Text>
					</h1>

					<p>
						<Text variant='large'>
							{
								"Sorry, we're not accepting applications for new shows at the moment."
							}
						</Text>
					</p>
				</div>
			);
		}

		let { title, description, categories } = vacancy;

		if (this.state.askContinue) {
			return (
				<div className={style.main}>
					<div className={style.background_image}>
						<img src='https://images.pexels.com/photos/3642350/pexels-photo-3642350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260' />
					</div>

					<img src="https://insanityradio.com/res/headphones_white.svg?" style={{ height: '150px' }} />
					<h1>
						<Text variant='xxLarge'>{title}</Text>
					</h1>

					<p>
						<Text variant='large'>{description}</Text>
					</p>

					<p>
						<Text variant='medium'>
							Would you like to continue your existing application?<br />

							<button onClick={ this._continue } className={ style.button }>
								Continue
							</button>

							<button onClick={ this._reset } className={ style.button + ' ' + style.button_secondary }>
								Start New
							</button>
						</Text>
					</p>
				</div>
			);
		}

		if (this.state.category && this.state.apply) {
			return this.renderForm();
		}

		if (this.state.category) {
			return this.renderCalendar();
		}

		categories = categories.filter(c => !c.from);

		return (
			<div className={style.main}>
				<div className={style.background_image}>
					<img src='https://images.pexels.com/photos/3642350/pexels-photo-3642350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260' />
				</div>

				<img src="https://insanityradio.com/res/headphones_white.svg?" style={{ height: '150px' }} />
				<h1>
					<Text variant='xxLarge'>{title}</Text>
				</h1>

				<p>
					<Text variant='large'>{description}</Text>
				</p>

				<p>
					<Text variant='medium'>
						To get started, choose a type of show to see more
						detail.
					</Text>
				</p>

				<div className={style.categoriesB}>
					{categories.map((cat) => (
						<div className={style.category}>
							<button
								className={style.button}
								onClick={this._setCategory.bind(this, cat)}
							>
								<Text variant='large'>{cat.title}</Text>
							</button>

							<p><Text variant="medium">{ cat.tease }</Text></p>
						</div>
					))}
				</div>
			</div>
		);
	}

	renderCalendar = () => {
		let { category } = this.state;

		let { title, description, times_available: times } = category;

		let { vacancy } = this.props.data;
		let { categories } = vacancy;

		let subcats = categories.filter(c => c.from == category.name);

		return (
			<div className={style.main}>
				<div className={style.background_image}>
					<img src='https://images.pexels.com/photos/3642350/pexels-photo-3642350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260' />
				</div>

				<div style={{ display: 'flex', flexDirection: 'column', maxWidth: '920px' }}>
					<h1>
						<IconButton onClick={this._back} iconProps={back} />
						&nbsp;&nbsp;&nbsp;<Text variant='xxLarge'>{title}</Text>
					</h1>

					<p>
						<Text variant='large'>{description}</Text>
					</p>

					<button className={style.button} onClick={this._apply}>
						<Text variant='large'>Apply Now</Text>
					</button>

					{
						subcats && subcats.length &&
							<Fragment>
								<p>
									<Text variant='large'>Want some inspiration for show ideas? You can also sign up for the following <b>core</b> programmes:</Text>
								</p>


								<div style={{ display: 'flex', justifyContent: 'center' }}>
									{
										subcats.map(cat => 
											<button
												className={style.button}
												style={{ marginLeft: 5, marginRight: 5 }}
												onClick={this._setCategory.bind(this, cat)}
											>
												<Text variant='large'>{cat.title}</Text>
											</button>
										)
									}
								</div>
							</Fragment>
						|| null
					}

					<p>
						<Text>
							To keep Insanity Radio consistent day to day, we generally
							broadcast this type of show at the following times:
						</Text>
					</p>
					<div className={style.calendar}>
						{Object.keys(daysOfWeek).map((day) => (
							<div className={style.date}>
								<Text className={style.day}>
									{daysOfWeek[day]}
								</Text>

								{hours.map((hr) => (
									<div
										className={
											(
												(times[day] && times[day]) ||
												(Array.isArray(times) &&
													times) ||
												[]
											).includes(hr)
												? style.valid
												: style.no
										}
									>
										<Text variant='tiny'>
											{('00' + hr).slice(-2)}
										</Text>
									</div>
								))}
							</div>
						))}
					</div>
				</div>
			</div>
		);
	};

	renderForm = () => {
		let { category } = this.state;

		let { title, description, times_available: times } = category;

		let body = null,
			form = true;

		const studentOrCommunity = [
			{
				key: 'student',
				text: 'Current Student',
				onRenderField: (props, defaultRender) => {
					return (
						<Fragment>
							{defaultRender(props)}

							<TextField
								underlined
								disabled={!props || !props.checked}
								defaultValue={this.state.student_number}
								onChange={this.change.bind(
									this,
									'student_number'
								)}
								placeholder='Student number'
							/>
						</Fragment>
					);
				},
			},
			{
				key: 'alumni',
				text: 'Insanity Radio alumni',
			},
			{
				key: 'community',
				text: 'Member of the community',
			},
		];

		const morePeople = [
			{
				key: false,
				text: 'I\'m a solo presenter'
			},
			{
				key: true,
				text: 'We\'re a presenting team',
				onRenderField: (props, defaultRender) => {
					if (!props.checked) {
						return defaultRender(props);
					}

					return (
						<div style={{ marginLeft: '-4px' }}>
							{defaultRender(props)}

							<TextField
								underlined
								multiline
								autoAdjustHeight
								resizable={ false }
								disabled={!props || !props.checked}
								defaultValue={this.state.student_number}
								onChange={this.change.bind(
									this,
									'student_number'
								)}
								placeholder="Other presenter's names"
							/>
						</div>
					);
				},
			}
		]

		switch (this.state.screen) {
			default:
				body = (
					<Fragment>
						<TextField
							underlined
							autocomplete='name'
							placeholder='Your full name'
							onChange={this.change.bind(this, 'name')}
							key='name'
							defaultValue={this.state.name}
						/>

						<TextField
							underlined
							autocomplete='pronouns'
							placeholder='Preferred pronouns'
							onChange={this.change.bind(this, 'pronouns')}
							key='pronouns'
							defaultValue={this.state.pronouns}
						/>

						<TextField
							underlined
							type='email'
							placeholder='Your email address'
							onChange={this.change.bind(this, 'email')}
							key='email'
							defaultValue={this.state.email}
						/>

						<ChoiceGroup
							options={studentOrCommunity}
							key='show-type'
							defaultSelectedKey={this.state.type}
							onChange={this.change.bind(this, 'type')}
						/>

						<button className={style.button} onClick={this._new}>
							<Text variant='large'>
								{"I'm applying for a new show"}
							</Text>
						</button>

						<button
							className={
								style.button + ' ' + style.button_secondary
							}
							onClick={this._returning}
						>
							<Text variant='large'>
								{"I'm applying to keep my show"}
							</Text>
						</button>
					</Fragment>
				);
				break;

			case 1:
				body = (
					<Fragment>
						<TextField
							multiline
							autoAdjustHeight
							underlined
							placeholder='Pitch your show to us - what music would you play? What might you talk about? The more detail the better!'
							onChange={this.change.bind(this, 'show_pitch')}
							key='show-pitch'
							defaultValue={this.state.show_pitch}
						/>

						<ChoiceGroup
							options={morePeople}
							key='show-choice'
							defaultSelectedKey={this.state.more_people}
							onChange={this.change.bind(this, 'more_people')}
						/>

						<button className={style.button} onClick={this._next}>
							<Text variant='large'>{'Next'}</Text>
						</button>
					</Fragment>
				);
				break;

			case 2:
				body = (
					<Fragment>
						<TextField
							underlined
							placeholder={
								this.state.returning
									? 'Tell us your show name'
									: 'Do you have a name for your show?'
							}
							onChange={this.change.bind(this, 'show_name')}
							key='show-name'
							defaultValue={this.state.show_name}
						/>

						<button className={style.button} onClick={this._next}>
							<Text variant='large'>{'Next'}</Text>
						</button>
					</Fragment>
				);
				break;

			case 3:
				body = (
					<Fragment>
						<TextField
							multiline
							autoAdjustHeight
							underlined
							placeholder={
								"Tell us a bit about yourself. For example, if you have any prior experience in radio (which isn't required)"
							}
							onChange={this.change.bind(this, 'bio')}
							key='prior-exp'
							defaultValue={this.state.bio}
						/>

						<button className={style.button} onClick={this._next}>
							<Text variant='large'>{'Next'}</Text>
						</button>
					</Fragment>
				);
				break;

			case 4:
				body = (
					<Fragment>
						<p>
							<Text variant='large'>
								Please provide your availability.
							</Text>
						</p>
						<p>
							<Text>
								We politely ask that you select as many times as
								possible, so we can ensure the schedule is
								allocated fairly.{' '}
							</Text>
						</p>
						<p>
							<Text>
								<b>
									Hint: Click or tap twice to mark a time as
									'not preferred' - it will appear yellow.
								</b>
							</Text>
						</p>
						{this.renderCalendarPicker()}

						<div style={{ margin: '10px 0 20px' }}>
							<Dropdown
								options={ showHours }
								onChange={ this.change.bind(this, 'show_length') }
								defaultSelectedKey={ this.state.show_length || 0 }
							/>
						</div>

						<button
							className={style.button}
							style={{ marginBottom: '50px' }}
							onClick={this._next}
						>
							<Text variant='large'>{'Review'}</Text>
						</button>
					</Fragment>
				);
				form = false;
				break;

			case 5:
				body = (
					<Fragment>
						<div>
							<p>
								<Text>Your Name: {this.state.name}</Text>
							</p>
							<p>
								<Text>Your Email: {this.state.email}</Text>
							</p>
							<p>
								<Text>
									Your Status:{' '}
									{(this.state.type && (studentOrCommunity.find(s => s.key == this.state.type) || {}).text) +
										' ' +
										(this.state.type == 'student'
											? '(' +
											  this.state.student_number +
											  ')'
											: '')}
								</Text>
							</p>
							<br />
							<p>
								<Text>
									Type Of Show: {this.state.category.title}
								</Text>
							</p>
							<p>
								<Text>
									Show Pitch:{' '}
									{this.state.show_pitch || (
										<i>not entered</i>
									)}
								</Text>
							</p>
							<p>
								<Text>
									Show Name:{' '}
									{this.state.show_name || <i>not entered</i>}
								</Text>
							</p>
							<br />
							<p>
								<Text>
									Available Times:{' '}
									{this.state.selectedHours &&
										Object.keys(this.state.selectedHours)
											.map(
												(s) =>
													[
														s,
														daysOfWeek[
															s.split('-')[0]
														] +
														' ' +
														(
															'00' + s.split('-')[1]
														).slice(-2) +
														':00'
													]
											)
											.map(
												([key, val]) => <span key={ key } className={ this.state.selectedHours[key] == 2 ? style.tentative : style.normal }>{ val }, </span>
											)
									}
								</Text>
							</p>
							<br />
							<button
								className={style.button}
								onClick={this._send}
							>
								<Text variant='large'>{'Apply'}</Text>
							</button>
						</div>
					</Fragment>
				);
		}

		if (this.state.submitting) {
			body = (
				<div>
					<Spinner size={ SpinnerType.large } />
				</div>
			)
		}

		if (this.state.done) {
			body = (
				<div>
					<h1><Text variant="xLarge">We've got it!</Text></h1>

					<p><Text>Thank you for applying for a radio show. We've got your application, and will be in touch very soon to discuss your show idea!</Text></p>
				</div>
			)
		}

		return (
			<div className={style.main + ' ' + ((form && style.form) || '')}>
				<div className={style.background_image}>
					<img src='https://images.pexels.com/photos/3642350/pexels-photo-3642350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260' />
				</div>

				<div style={{ display: 'flex', flexDirection: 'column', maxWidth: '920px' }}>
					<h1>
						<IconButton onClick={this._back} iconProps={back} />
						&nbsp;&nbsp;&nbsp;
						<Text variant='xxLarge'>Applying for {title}</Text>
					</h1>

					{body}
				</div>
			</div>
		);
	};

	_send = () => {
		// console.log('got final data', JSON.stringify(this.state));
		// alert('NOTE: stubbed. see console for json')
		this.setState({
			submitting: true
		}, () => {
			this.submit()
		})
	};

	submit = async () => {
		let theData = JSON.stringify(this.state);

		try {
			const body = String(theData);

			console.log('body teest', theData, body, this.state, this)

			let response = await fetch('/api/submit_application', { method: 'POST', body, headers: { 'Content-Type': 'application/json' } });

			let data = await response.json();

			if (!data.success) {
				throw new Error('Something went wrong!');
			}

			this.setState({
				done: true
			})
		} catch (e) {
			this.setState({
				submitting: false				
			})
			alert('Sorry, something went wrong. Try submitting again')

		}
	}

	renderCalendarPicker() {
		let { category } = this.state;

		let { title, description, times_available: times } = category;

		let { selectedHours } = this.state;

		if (!selectedHours) {
			selectedHours = [];
		}

		return (
			<div className={style.calendar}>
				{Object.keys(daysOfWeek).map((day) => (
					<div className={style.date}>
						<Text className={style.day}>{daysOfWeek[day]}</Text>

						{hours.map((hr) => (
							<div
								tabIndex={
									(
										(times[day] && times[day]) ||
										(Array.isArray(times) && times) ||
										[]
									).includes(hr)
										? 0
										: -1
								}
								onClick={this._selectHour.bind(this, day, hr)}
								onKeyDown={checkForEnter(
									this._selectHour.bind(this, day, hr)
								)}
								className={
									(selectedHours[day + '-' + hr]
										? style.selected_time + ' '
										: '') +
									(selectedHours[day + '-' + hr] == 2
										? style.tentative + ' '
										: '') +
									((
										(times[day] && times[day]) ||
										(Array.isArray(times) && times) ||
										[]
									).includes(hr)
										? style.choosable
										: style.not_choosable)
								}
							>
								<Text variant='tiny'>
									{('00' + hr).slice(-2)}
								</Text>
							</div>
						))}
					</div>
				))}
			</div>
		);
	}

	_selectHour = (day, hour) => {
		let { category } = this.state;

		let { title, description, times_available: times } = category;

		if (
			Array.isArray(times)
				? !times.includes(hour)
				: !times[day] || !times[day].includes(hour)
		) {
			return;
		}

		let selectedHours = Object.assign({}, this.state.selectedHours);

		selectedHours[day + '-' + hour] = selectedHours[day + '-' + hour]
			? (selectedHours[day + '-' + hour] + 1) % 3 || false
			: 1;

		if (!selectedHours[day + '-' + hour]) {
			delete selectedHours[day + '-' + hour];
		}		

		this.setState({
			selectedHours,
		});
	};

	change = (field, event, value) => {
		if (typeof value == 'object' && value && value.key) {
			value = value.key;
		}
		this.setState({
			[field]: value,
		});
	};

	_next = () => {
		let screen = (this.state.screen || 0) + 1;
		console.log('screen', screen);

		if (screen == 1) {
			if (
				!this.state.name ||
				!this.state.email ||
				!this.state.type ||
				(this.state.type == 'student' && !this.state.student_number)
			) {
				return alert('Please fill out the required fields!');
			}

			if (this.state.category.core) {
				screen = 3;
			}
		}

		if (screen == 5) {
			if (!this.state.show_length) {
				return alert('Please fill out the required fields!')
			}

			if (Object.keys(this.state.selectedHours).length < 2) {
				return alert('Please select at least 2 hours that you are available.')
			}

			if (Object.keys(this.state.selectedHours).length < 4) {
				if (!confirm('You should select at least 4 hours that you are available, or we may not be able to allocate you a time. Are you sure you want to continue?')) return;
			}
		}

		this.setState({
			screen,
		});
	};

	_new = () => {
		this.setState(
			{
				returning: false,
			},
			this._next
		);
	};

	_returning = () => {
		this.setState(
			{
				returning: true,
			},
			this._next
		);
	};

	_back = () => {
		this.setState({
			category: this.state.apply ? this.state.category : null,
			apply: this.state.screen ? this.state.apply : false,
			screen: Math.max(0, this.state.screen - 1),
		});
	};

	_apply = () => {
		this.setState({
			apply: true,
		});
	};

	_setCategory = (category) => {
		this.setState({
			category,
		});
	};
}
